import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { Save } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  FormControl,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import contractsApi from 'Api/contracts';

import { usePortfolioContext } from 'Components/Portfolios/context';

const EditContract = ({ id, cancel }) => {
  const [contract, setContract] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { handleSubmit, register, setValue, formState } = useForm();
  const { fetchPortfoliosAndSites } = usePortfolioContext();

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      fetchContractById(id);
    }
  }, []);

  const fetchContractById = async (id) => {
    const data = await contractsApi.getContract(id);
    setContract(data?.data?.data ?? null);
    setValue('contractname', data?.data?.data?.contractname ?? '');
    setIsLoading(false);
  };

  const onSubmit = (data) => {
    setIsLoading(true);
    contractsApi
      .updateContract(id, data)
      .then(() => {
        fetchPortfoliosAndSites();
        cancel();
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderForm = () => {
    if (contract && !isLoading) {
      return (
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl fullWidth>
            <TextField
              id="contract-id"
              fullWidth
              required
              label="Contract name"
              margin="normal"
              {...register('contractname')}
            />
          </FormControl>
          <Stack direction="row" justifyContent="space-between" mt={2}>
            <Button
              variant="contained"
              startIcon={<Save />}
              disabled={!formState.isDirty}
              type="submit"
            >
              Save
            </Button>
            <ButtonGroup>
              <Button onClick={cancel}>Cancel</Button>
            </ButtonGroup>
          </Stack>
        </form>
      );
    }
    return null;
  };

  return (
    <Stack p={2} spacing={2}>
      {isLoading && <LinearProgress />}
      <Typography variant="h5">Edit contract {id}</Typography>
      <Box py={2}>{renderForm()}</Box>
      {!!error && (
        <Alert severity="error">Error when updating the contract</Alert>
      )}
    </Stack>
  );
};

export default EditContract;
